import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import icoSuccess from 'assets/images/dialogs/ChargeSuccessful.svg';
import icoSentEmail from 'assets/images/dialogs/EmailReceiptSent.svg';
import InlineSpinner from 'components/generic/InlineSpinner.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalon, selectCurrentSalonId } from 'selectors/currentSalon.selectors';

import { clearDepositRefunded, fetchClient, sendRefundEmail } from 'settings/balance-sheet/actions';
import ConfirmationDialog from 'settings/balance-sheet/ConfirmationDialog';
import Email from 'settings/balance-sheet/Email';

import CN from './SendReceiptAfterDeposit.module.scss';

export class SendReceiptAfterDeposit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      invalidEmail: false,
      emailSent: false,
      closeEmailSent: false,
      confirmUpdateDialog: false,
    };
  }

  componentDidMount() {
    if (this.props.clientViewData.response && this.props.clientViewData.response.deposits_list.length > 0 && this.props.clientViewData.response.deposits_list[0].clientId) {
      this.props.getClient({
        id: this.props.clientViewData.response.deposits_list[0].clientId,
        salon_id: this.props.salonId,
      });
    }
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.client && nextProps.client.email) {
      this.setState({ email: nextProps.client.email });
    }
  }

  componentWillUnmount() {
    this.props.clearDepositRefunded();
    this.props.history.push(`/salon/${this.props.salonId}/deposits`);
  }

  onEmailChange = (event) => void this.setState({ email: event.target.value });

  sendEmail = (to, subject, html, text) => void this.props.sendRefundEmail(to, subject, html, text);

  sendReceiptToEmail = () => {
    const emailValidation = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const { email } = this.state;
    const { t } = this.props;

    if (emailValidation.test(email)) {
      this.setState({ invalidEmail: false }, () => {
        const receipt = document.getElementById('receipt');
        if (receipt) {
          this.sendEmail(email, t('balanceSheet.emailReceipt.depositRefundFrom', { salonName: this.props.salonDetails.name }), receipt.outerHTML, t('balanceSheet.emailReceipt.htmlEmailsSupport'));
          this.setState({ emailSent: true });
          setTimeout(() => {
            this.setState({ closeEmailSent: true });
            this.props.history.push(`/salon/${this.props.salonId}/deposits`);
          }, 3000);
          this.setState({ confirmUpdateDialog: true });
        }
      });
    } else {
      this.setState({ invalidEmail: true });
    }
  };
  close = () => {
    this.props.clearDepositRefunded();
    this.props.history.push(`/salon/${this.props.salonId}/deposits`);
  };

  printA4 = () => {
    this.setState({}, () => {
      if (document.body) {
        const printContent = document.getElementById('receipt');
        const successPopup = document.querySelector('.chk-popup');
        if (successPopup) {
          successPopup.style.display = 'none';
        }
        const header = document.getElementById('header');
        if (printContent) {
          printContent.style.display = 'block';
          if (header) {
            header.style.display = 'none';
          }
          window.print();
          if (header) {
            header.style.display = 'block';
          }
          this.setState({});
          this.props.history.push(`/salon/${this.props.salonId}/deposits`);
        }
      }
    });
  };
  updateClientEmail = () => {
    this.setState({ confirmUpdateDialog: false });
    if (this.props.client.id) {
      this.props.updateClient({
        id: this.props.client.id,
        email: this.state.email,
        salon_id: this.props.salonId,
      });
    }
  };

  render() {
    const { t } = this.props;

    const buttonText = this.props.isFetching ? t('common.loading') : t('balanceSheet.emailReceipt.sendReceipt');

    return (
      <div className="settings">
        {this.state.confirmUpdateDialog && (
          <ConfirmationDialog
            title={t('balanceSheet.emailReceipt.updateClientEmailModal.title')}
            leftButtonText={t('common.buttons.no')}
            onLeft={() => this.setState({ confirmUpdateDialog: false })}
            rightButtonText={t('common.buttons.yes')}
            onRight={this.updateClientEmail}
            onCancel={() => this.setState({ confirmUpdateDialog: false })}
          >
            <p>{t('balanceSheet.emailReceipt.updateClientEmailModal.description')}</p>
          </ConfirmationDialog>
        )}

        <Email depositRefunded={this.props.depositRefunded} salonDetails={this.props.salonDetails} />

        <div style={{ zIndex: '11100', marginTop: '-196px' }} data-cy="send-receipt-modal" className="chk-popup">
          {this.state.emailSent && !this.state.closeEmailSent && (
            <div>
              <div className="chk-popup-header">
                <h2>{t('balanceSheet.emailReceipt.receiptSent')}</h2>
              </div>
              <div className="chk-popup-wrap" style={{ position: 'relative' }}>
                <div className="chk-popup-row-lrg">
                  <img src={icoSentEmail} alt="Email sent" />
                  <br />
                  <p className="text-dark">{t('balanceSheet.emailReceipt.receiptSentTo', { email: this.state.email })}</p>
                </div>
              </div>
            </div>
          )}
          {!this.state.emailSent && this.props.depositRefunded && (
            <div>
              {/* TODO:change this with salon modal */}

              <div>
                <div>
                  {!this.props.isFetching && (
                    <div className={CN.container}>
                      <div className={CN.modalTitle}>{t('balanceSheet.emailReceipt.depositRefundSuccess')}</div>
                      <img src={icoSuccess} alt="success" />
                      <div className={CN.modalSubtitle}>
                        <div className={CN.amount}>
                          <CurrencySign value={-this.props.depositRefunded.amount} />
                        </div>
                        {t('balanceSheet.emailReceipt.hasBeenRefunded')}
                      </div>
                      <div className={CN.modalSubtitle}> {t('balanceSheet.emailReceipt.sendEmailReceipt')}</div>
                      <div className={CN.inputContainer}>
                        <input
                          type="text"
                          className={cn({
                            'chk-popup-email-input': true,
                            [CN.emailInput]: true,
                          })}
                          placeholder={t('balanceSheet.emailReceipt.clientEmailAddressPlaceholder')}
                          value={this.state.email}
                          onChange={this.onEmailChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  )}
                  {this.props.isFetching && (
                    <div className={CN.container}>
                      <div className={CN.modalTitle}>{t('balanceSheet.emailReceipt.depositRefundSuccess')}</div>
                      <div className={CN.modalSubtitle}>{t('balanceSheet.emailReceipt.confirmationLoading')}</div>
                      <div className={CN.spinnerContainer}>
                        <InlineSpinner variant="small" />
                      </div>
                    </div>
                  )}
                  {this.state.invalidEmail && (
                    <div className="error-mess">
                      <div>{t('balanceSheet.emailReceipt.invalidEmailAddress')}</div>
                      <div>{t('balanceSheet.emailReceipt.checkSpelling')}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {!this.state.emailSent && this.props.depositRefunded && (
            <div className="chk-popup-footer cfix">
              <div className="chk-popup-row tree-btn">
                <button className="chk-ftr-btn chk-ftr-print-btn" onClick={this.printA4}>
                  {t('balanceSheet.emailReceipt.printA4')}
                </button>
                <button className="chk-ftr-btn chk-ftr-close-btn" onClick={this.close}>
                  {t('common.buttons.close')}
                </button>
                {!this.state.emailSent && (
                  <button className="chk-ftr-btn chk-ftr-send-btn" onClick={this.sendReceiptToEmail}>
                    {buttonText}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const SendReceiptAfterDepositHoc = connect(
  (state) => ({
    client: state?.settings?.balanceSheet?.edit_client.data,
    isFetching: state?.settings?.balanceSheet?.edit_client.isFetching,
    clientViewData: state?.settings?.balanceSheet?.clientViewData,
    salonId: selectCurrentSalonId(state),
    salonDetails: selectCurrentSalon(state),
    editClient: state?.settings?.balanceSheet?.editClient,
    depositRefunded: state?.settings?.balanceSheet?.depositRefunded,
  }),
  (dispatch) => ({
    sendRefundEmail(to, subject, html) {
      dispatch(sendRefundEmail(to, subject, html));
    },
    updateClient(data) {
      dispatch(fetchClient(data.salon_id, data, 'PUT'));
    },
    getClient(data) {
      dispatch(fetchClient(data.salon_id, data, 'GET'));
    },
    clearDepositRefunded() {
      dispatch(clearDepositRefunded());
    },
  }),
)(withTranslation()(SendReceiptAfterDeposit));

export default SendReceiptAfterDepositHoc;
